"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { forgetPassword } from "../register/login";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
const forgetPasswordFormSchema = z.object({
  email: z.string().email("email id is invalid"),
});

export const ForgetPasswordForm = () => {
  const form = useForm<z.infer<typeof forgetPasswordFormSchema>>({
    resolver: zodResolver(forgetPasswordFormSchema),
    defaultValues: {
      email: "",
    },
  });
  const router = useRouter();

  async function onSubmit(values: z.infer<typeof forgetPasswordFormSchema>) {
    // Do something with the form values.
    // ✅ This will be type-safe and validated.

    const res = await forgetPassword(values);
    if (res.success) {
      toast.success(res.message, { position: "top-center" });
      form.reset();
      router.replace("/login");
    } else {
      toast.error(res.message, { position: "top-center" });
    }
  }

  return (
    <div className="w-[90%] rounded-lg bg-neutral-100 p-5 dark:bg-neutral-900 md:w-1/2 lg:w-1/3 xl:w-1/4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
          <span className="text-sm text-neutral-800 dark:text-neutral-400">
            Don&apos;t worry! we are here...
          </span>
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel
                  className="text-neutral-600 dark:text-neutral-500"
                  required={true}
                >
                  Your email address
                </FormLabel>
                <FormControl>
                  <Input
                    placeholder="abhay.sharma@gmail.com"
                    {...field}
                    className="text-neutral-800 dark:text-neutral-200"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button
            type="submit"
            size="lg"
            className="bg-brand-800 hover:bg-brand-600 dark:hover:bg-brand-600/50 w-full gap-2 text-white"
          >
            Send Reset Password Link
          </Button>
        </form>
      </Form>
    </div>
  );
};
